import { useContext, useEffect } from "react";
import { BoardContext, TeamContext } from "../../../context";
import questionLock from "../../../assets/icons/questionLock.svg";
import question from "../../../assets/cards/question_card_back.svg";
import heartWithCoin from "../../../assets/icons/heartWithCoin.svg";
import action from "../../../assets/cards/questionAndAction.svg";
import cheerLock from "../../../assets/icons/cheer/cheer_btn-normal.svg";
import UpTokenCoin from "../../../assets/icons/upTokenCoin.svg";
import { useTranslation } from "react-i18next";

const RoundsTransitionFullScreen = () => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { setIsDilemmaOwnerAnouncementDone } = useContext(BoardContext);
    const numberOfSolvedDilemmas: number = game?.gameInfo.challengeScore || 0;
    const roundNumber : string = t("roundText") + (numberOfSolvedDilemmas + 1 );

    useEffect(() => {
        const textAnimate = setTimeout(() => {
            setIsDilemmaOwnerAnouncementDone("dilemmaOwnerAnouncement");
        }, 7000);

        return () => clearTimeout(textAnimate);
    }, [setIsDilemmaOwnerAnouncementDone])

    const getGenericRoundImage = (roundName: string) => {
        return (
            <div className="round_transitions_wrapper rounds_transitions_full_screen_question">
                <img className={`lock_image center_horizontally_and_vertically round_${roundDescriptionDict[roundName]}`} src={roundImagesDict[roundName]} alt="round" />
                <div className="lock_text"> {roundDescriptionDict[roundName]} </div>
            </div>
        )
    }

    const questionRound = () => {
        return getGenericRoundImage("question");
    }

    const tippingnRound = () => {
        if (numberOfSolvedDilemmas > 0)
            return getGenericRoundImage("tipping");
        return getGenericRoundImage("locked");
    }

    const actionRound = () => {
        if (numberOfSolvedDilemmas > 1)
            return getGenericRoundImage("action");
        return getGenericRoundImage("locked");
    }

    const cheerRound = () => {
        if (numberOfSolvedDilemmas >= 3)
            return getGenericRoundImage("cheer");
        return getGenericRoundImage("locked");
    }

    const roundImagesDict: any = {
        "question": question,
        "tipping": heartWithCoin,
        "action": action,
        "cheer": cheerLock,
        "locked": questionLock
    }

    const roundDescriptionDict: any = {
        "question": t("questionText"),
        "tipping": t("tippingText"),
        "action": t("questionAndActionText"),
        "cheer": t("cheerButtonText"),
        "locked": ""
    }

    return (
        <div className="dilemma_owner_anouncement_wrapper rounds_transitions_full_screen full_screen_vw_vh">
        
        <div className="rounds_transitions_full_screen_header">
            <div className="rounds_transitions_full_screen_header_title"> {roundNumber} </div> 
            <div className="gradient_line_holder center_horizontally_and_vertically" style={{height: "3vh", width: "80%"}}>
                <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
            </div> 
            {(numberOfSolvedDilemmas === 3) && <div className="double_point_round_holder">  
                <div className="double_point_round_wrapper">  
                    <img className="upper_token_img" src={UpTokenCoin} alt="upToken" />
                    <div className="double_point_round"> {t("doublePointRoundText")} </div>
                    <img className="upper_token_img" src={UpTokenCoin} alt="upToken" />
                </div>
            </div>}
        </div>

        <div className="rounds_transitions_full_screen_body">
            {questionRound()}
            {tippingnRound()}
            {actionRound()}
            {cheerRound()}
        </div>

        </div>
    )
}

export default RoundsTransitionFullScreen;